
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import { defineComponent, onMounted, ref } from "vue";
import { message } from "ant-design-vue";
import { useRouter } from "vue-router";
import {} from "vuex";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "SecuritySet",
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const activeKey = ref("1");
    const labelCol = { style: { width: "100px" } };
    const mUserName = ref("");
    const phoneNumber = ref("");
    const mOldPassword = ref<string>("");
    const newPassword = ref<string>("");
    const newPasswordAgain = ref<string>("");

    const getUserInfo = () => {
      Api.getUserInfo().then((val) => {
        if (val.err_no === ResultCodeType.success_200) {
          mUserName.value = val.result.username;
          phoneNumber.value = val.result.mobile;
        }
      });
    };
    const saveBaseInfo = () => {
      const param = {
        mobile: phoneNumber.value,
      };
      Api.userInfoEdit(param).then((val) => {
        if (val.err_no === ResultCodeType.success_200) {
          message.success(t("successfullymodified"));
          getUserInfo();
        } else {
          message.error(t("modificationfailed"));
        }
      });
    };
    const checkOldPwIsSameNew = () => {
      if (mOldPassword.value != newPassword.value) {
        return true;
      } else {
        message.error(t("passwordissame"));
        return false;
      }
    };
    const checkPwIsSame = () => {
      if (newPasswordAgain.value == newPassword.value) {
        return true;
      } else {
        message.error(t("twicenotsame"));
        return false;
      }
    };

    const savePassword = () => {
      if (checkOldPwIsSameNew() && checkPwIsSame()) {
        const param = {
          original_password: mOldPassword.value,
          new_password: newPassword.value,
          confirm_password: newPasswordAgain.value,
        };
        Api.changePassword(param).then((val) => {
          if (val.err_no == ResultCodeType.success_200) {
            message.success(t("successfullymodified"));
          } else {
            message.error(val.err_msg);
          }
        });
      }
    };
    const goBack = () => {
      router.go(-1);
    };
    onMounted(() => {
      getUserInfo();
    });
    return {
      activeKey,
      labelCol,
      mUserName,
      phoneNumber,
      mOldPassword,
      newPassword,
      newPasswordAgain,
      saveBaseInfo,
      goBack,
      savePassword,
      t,
    };
  },
});
